import { Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import Page from "@/components/Page";

import Content from "./content/Content";
import Sidebar from "./layout/sidebar";

const CalculatorsPage = () => {
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();

    return (
        <Page title={t("calc_panel")}>
            <Container sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Typography variant="h3" component="h1" paragraph>
                    {t("calc_panel")}
                </Typography>
                <Grid container gap={2}>
                    <Grid item xs={12} md={3}>
                        <Sidebar />
                    </Grid>
                    {id ? <Content /> : <></>}
                </Grid>
            </Container>
        </Page>
    );
};

export default CalculatorsPage;
